export const SHOW_PHOTOS = true;
export const FOOD_PHOTOS = false;

export const PHOTOS = {
  lamp: "/photos/lamp.jpg",
  plates: "/photos/plates.jpg",
  sketches: "/photos/sketches.jpg",
  texture: "/photos/texture.jpg",
  corridor: "/photos/corridor.jpg",
  sala: "/photos/sala.jpg",
  tableSetting: "/photos/table-setting.jpg",
  wineNiche: "/photos/wine-niche.jpg",
  dishPrawn: "/photos/dish-prawn.jpg",
  fire: "/photos/fire.jpg",
};

export const MENU_ITEMS = [
  {
    cat: "fritti",
    name: "Alici di Fuscaldo croccanti",
    name_en: "Crispy Fuscaldo anchovies",
    desc: "Salsa verde",
    desc_en: "Salsa verde",
    price: "8",
  },
  {
    cat: "fritti",
    name: "Crocchette di gamberi rosa",
    name_en: "Pink shrimp croquettes",
    desc: "Maionese al bergamotto",
    desc_en: "Bergamot mayonnaise",
    price: "12",
  },
  {
    cat: "fritti",
    name: "Crocchette di stocco",
    name_en: "Stockfish croquettes",
    desc: "Salsa al Moscato di Saracena",
    desc_en: "Moscato di Saracena sauce",
    price: "10",
  },
  {
    cat: "fritti",
    name: "Crocchetta di morsello",
    name_en: "Morsello croquette",
    desc: "Maionese alla 'nduja",
    desc_en: "'Nduja mayonnaise",
    price: "10",
  },
  {
    cat: "fritti",
    name: "Bocconcini di pollo",
    name_en: "Chicken bites",
    desc: "Salsa barbecue",
    desc_en: "Barbecue sauce",
    price: "8",
  },
  {
    cat: "antipasti",
    name: "Mozzarella di bufala",
    name_en: "Buffalo mozzarella",
    desc: "Con capocollo di Gammune o alici di Fuscaldo",
    desc_en: "With Gammune capocollo or Fuscaldo anchovies",
    price: "13",
  },
  {
    cat: "antipasti",
    name: "Burrata",
    name_en: "Burrata",
    desc: "Con peperone crusco",
    desc_en: "With crusco pepper",
    price: "13",
  },
  {
    cat: "antipasti",
    name: "Bruschetta Sant'Irene",
    name_en: "Bruschetta Sant'Irene",
    desc: "",
    desc_en: "",
    price: "10",
  },
  {
    cat: "antipasti",
    name: "Carpaccio di manzo",
    name_en: "Beef carpaccio",
    desc: "Pecorino crotonese, peperone crusco e olio extravergine monovarietale cassanese",
    desc_en: "Crotonese pecorino, crusco pepper & single-varietal Cassanese olive oil",
    price: "14",
  },
  {
    cat: "antipasti",
    name: "Focaccine con tartare di tonnetto di Amantea",
    name_en: "Focaccine with Amantea albacore tartare",
    desc: "Crema di melanzane affumicate e avocado",
    desc_en: "Smoked eggplant cream & avocado",
    price: "16",
  },
  {
    cat: "antipasti",
    name: "Tortino di melanzane violette di Longobardi",
    name_en: "Longobardi violet eggplant flan",
    desc: "Fonduta di caciocavallo silano e foglia di basilico",
    desc_en: "Silano caciocavallo fondue & basil leaf",
    price: "14",
  },
  {
    cat: "antipasti",
    name: "Panini cruschi con baccalà mantecato",
    name_en: "Cruschi panini with creamed salt cod",
    desc: "Composta di cedro",
    desc_en: "Citron compote",
    price: "14",
  },
  {
    cat: "antipasti",
    name: "Tagliata di pancetta fondente",
    name_en: "Melting pancetta tagliata",
    desc: "Torta di patate “mpacchiuse” e mostarda della Tuscia",
    desc_en: "“Mpacchiuse” potato cake & Tuscia mostarda",
    price: "12",
  },
  {
    cat: "antipasti",
    name: "Empanadas Sant'Irene",
    name_en: "Empanadas Sant'Irene",
    desc: "Chimichurri e salsa criolla",
    desc_en: "Chimichurri & salsa criolla",
    price: "8",
  },
  {
    cat: "primi",
    name: "Struncatura aglio, olio e peperoncino",
    name_en: "Struncatura garlic, olive oil & chili",
    desc: "Calamaretti scottati e peperone crusco",
    desc_en: "Seared baby squid & crusco pepper",
    price: "15",
  },
  {
    cat: "primi",
    name: "Busiata con moscardini",
    name_en: "Busiata with baby octopus",
    desc: "Pomodorini di Belmonte appassiti e zeste di bergamotto",
    desc_en: "Sun-dried Belmonte cherry tomatoes & bergamot zest",
    price: "15",
  },
  {
    cat: "primi",
    name: "Ravioli di ricotta di pecora ed erbe spontanee",
    name_en: "Sheep's ricotta & wild herb ravioli",
    desc: "Il “Ragù della festa”",
    desc_en: "The “Feast Ragù”",
    price: "15",
  },
  {
    cat: "primi",
    name: "Lagane fatte in casa e ceci",
    name_en: "Homemade lagane & chickpeas",
    desc: "Gambero rosso, crudo e cotto",
    desc_en: "Red prawn, raw & cooked",
    price: "16",
  },
  {
    cat: "primi",
    name: "Gnocchi alla crema di melanzane violette di Longobardi",
    name_en: "Gnocchi in Longobardi violet eggplant cream",
    desc: "Ricotta salata dell'Aspromonte",
    desc_en: "Aspromonte salted ricotta",
    price: "14",
  },
  {
    cat: "secondi",
    name: "Pesce spada “alla ghiotta”",
    name_en: "Swordfish “alla ghiotta”",
    desc: "",
    desc_en: "",
    price: "23",
  },
  {
    cat: "secondi",
    name: "Filetto di spigola",
    name_en: "Sea bass fillet",
    desc: "Purè di ceci di Gerace e torta di patate all'origano",
    desc_en: "Gerace chickpea purée & oregano potato cake",
    price: "23",
  },
  {
    cat: "secondi",
    name: "Maialino nero della Sila",
    name_en: "Sila black piglet",
    desc: "Chutney di pera, purè affumicato e riduzione di passito",
    desc_en: "Pear chutney, smoked purée & passito reduction",
    price: "20",
  },
  {
    cat: "secondi",
    name: "Guancia di vitello",
    name_en: "Veal cheek",
    desc: "Purè di patate al rosmarino e salsa al Magliocco",
    desc_en: "Rosemary potato purée & Magliocco wine sauce",
    price: "20",
  },
  {
    cat: "secondi",
    name: "Sovraccoscio di pollo di cortile alle erbe",
    name_en: "Free-range chicken thigh with herbs",
    desc: "Salsa ai peperoni",
    desc_en: "Pepper sauce",
    price: "18",
  },
  {
    cat: "secondi",
    name: "Hamburger Sant'Irene",
    name_en: "Hamburger Sant'Irene",
    desc: "",
    desc_en: "",
    price: "15",
  },
  {
    cat: "dolci",
    name: "Tiramisù espresso",
    name_en: "Espresso tiramisù",
    desc: "",
    desc_en: "",
    price: "8",
  },
  {
    cat: "dolci",
    name: "Tortino di cioccolato Domori 75%",
    name_en: "Domori 75% chocolate fondant",
    desc: "Dal cuore morbido",
    desc_en: "Soft-centred",
    price: "8",
  },
  {
    cat: "dolci",
    name: "Panna cotta alla liquirizia",
    name_en: "Liquorice panna cotta",
    desc: "",
    desc_en: "",
    price: "8",
  },
  {
    cat: "dolci",
    name: "Tartufo di Pizzo",
    name_en: "Tartufo di Pizzo",
    desc: "",
    desc_en: "",
    price: "8",
  },
  {
    cat: "dolci",
    name: "Latte in piedi",
    name_en: "Latte in piedi",
    desc: "",
    desc_en: "",
    price: "8",
  },
];

export const LUNCH_MENU_ITEMS = [
  {
    cat: "insalate",
    name: "Insalata mista con primo sale",
    name_en: "Mixed salad with primo sale cheese",
    desc: "Noci, avocado e pesto di menta",
    desc_en: "Walnuts, avocado & mint pesto",
    price: "12",
  },
  {
    cat: "insalate",
    name: "Insalata mista con prosciutto di pesce spada",
    name_en: "Mixed salad with swordfish prosciutto",
    desc: "Papaya e citronette al mandarino",
    desc_en: "Papaya & mandarin citronette",
    price: "14",
  },
  {
    cat: "insalate",
    name: "Insalata mista con filetto di tonno di Amantea",
    name_en: "Mixed salad with Amantea tuna fillet",
    desc: "Pomodori secchi e crostini di pane al finocchietto",
    desc_en: "Sun-dried tomatoes & fennel bread crostini",
    price: "14",
  },
  {
    cat: "insalate",
    name: "Carpaccio di manzo",
    name_en: "Beef carpaccio",
    desc: "Pecorino crotonese, peperone crusco e olio extravergine monovarietale cassanese",
    desc_en: "Crotonese pecorino, crusco pepper & single-varietal Cassanese olive oil",
    price: "14",
  },
  {
    cat: "insalate",
    name: "“Cuccìa” con funghi pioppini",
    name_en: "“Cuccìa” wheat with pioppini mushrooms",
    desc: "Gamberi e zucchine marinate",
    desc_en: "Prawns & marinated zucchini",
    price: "14",
  },
  {
    cat: "insalate",
    name: "Bocconcini di pollo al curry",
    name_en: "Curry chicken bites",
    desc: "Riso basmati e verdurine croccanti",
    desc_en: "Basmati rice & crispy vegetables",
    price: "14",
  },
  {
    cat: "insalate",
    name: "Empanadas Sant'Irene",
    name_en: "Empanadas Sant'Irene",
    desc: "Chimichurri e salsa criolla",
    desc_en: "Chimichurri & salsa criolla",
    price: "12",
  },
  {
    cat: "fritti",
    name: "Alici di Fuscaldo croccanti",
    name_en: "Crispy Fuscaldo anchovies",
    desc: "Salsa verde",
    desc_en: "Salsa verde",
    price: "8",
  },
  {
    cat: "fritti",
    name: "Crocchette di gamberi rosa",
    name_en: "Pink shrimp croquettes",
    desc: "Maionese al bergamotto",
    desc_en: "Bergamot mayonnaise",
    price: "12",
  },
  {
    cat: "fritti",
    name: "Bocconcini di pollo croccanti",
    name_en: "Crispy chicken bites",
    desc: "Salsa barbecue",
    desc_en: "Barbecue sauce",
    price: "8",
  },
  {
    cat: "fattoria",
    name: "Mozzarella di bufala con capocollo di Gammune",
    name_en: "Buffalo mozzarella with Gammune capocollo",
    desc: "",
    desc_en: "",
    price: "13",
  },
  {
    cat: "fattoria",
    name: "Mozzarella di bufala con alici di Fuscaldo",
    name_en: "Buffalo mozzarella with Fuscaldo anchovies",
    desc: "",
    desc_en: "",
    price: "13",
  },
  {
    cat: "fattoria",
    name: "Burrata",
    name_en: "Burrata",
    desc: "Con peperone crusco",
    desc_en: "With crusco pepper",
    price: "13",
  },
  {
    cat: "primiTradizione",
    name: "Rigatoni alla carbonara",
    name_en: "Rigatoni alla carbonara",
    desc: "50 g · 100 g · 150 g",
    desc_en: "50 g · 100 g · 150 g",
    price: "10 · 12 · 15",
  },
  {
    cat: "primiTradizione",
    name: "Tonnarelli cacio e pepe",
    name_en: "Tonnarelli cacio e pepe",
    desc: "50 g · 100 g · 150 g",
    desc_en: "50 g · 100 g · 150 g",
    price: "10 · 12 · 15",
  },
  {
    cat: "primiTradizione",
    name: "Maccheroncini all'amatriciana",
    name_en: "Maccheroncini all'amatriciana",
    desc: "50 g · 100 g · 150 g",
    desc_en: "50 g · 100 g · 150 g",
    price: "10 · 12 · 15",
  },
  {
    cat: "primiCasa",
    name: "Ravioli di ricotta di pecora ed erbe spontanee",
    name_en: "Sheep's ricotta & wild herb ravioli",
    desc: "Il “Ragù della festa”",
    desc_en: "The “Feast Ragù”",
    price: "15",
  },
  {
    cat: "primiCasa",
    name: "Busiata con moscardini",
    name_en: "Busiata with baby octopus",
    desc: "Pomodorini di Belmonte appassiti e zeste di bergamotto",
    desc_en: "Sun-dried Belmonte cherry tomatoes & bergamot zest",
    price: "15",
  },
  {
    cat: "primiCasa",
    name: "Gnocchi alla crema di melanzane violette di Longobardi",
    name_en: "Gnocchi in Longobardi violet eggplant cream",
    desc: "Ricotta salata dell'Aspromonte",
    desc_en: "Aspromonte salted ricotta",
    price: "14",
  },
  {
    cat: "secondi",
    name: "Filetto di spigola",
    name_en: "Sea bass fillet",
    desc: "Purè di ceci di Gerace e torta di patate all'origano",
    desc_en: "Gerace chickpea purée & oregano potato cake",
    price: "23",
  },
  {
    cat: "secondi",
    name: "Sovraccoscio di pollo di cortile alle erbe",
    name_en: "Free-range chicken thigh with herbs",
    desc: "Salsa ai peperoni",
    desc_en: "Pepper sauce",
    price: "18",
  },
  {
    cat: "secondi",
    name: "Hamburger Sant'Irene",
    name_en: "Hamburger Sant'Irene",
    desc: "",
    desc_en: "",
    price: "15",
  },
  {
    cat: "dolci",
    name: "Tiramisù espresso",
    name_en: "Espresso tiramisù",
    desc: "",
    desc_en: "",
    price: "8",
  },
  {
    cat: "dolci",
    name: "Panna cotta alla liquirizia",
    name_en: "Liquorice panna cotta",
    desc: "",
    desc_en: "",
    price: "8",
  },
  {
    cat: "dolci",
    name: "Tartufo di Pizzo",
    name_en: "Tartufo di Pizzo",
    desc: "",
    desc_en: "",
    price: "8",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxmaW5lJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMGZvb2QlMjBwbGF0aW5nfGVufDB8fHx8MTc4OTk4MTMzNnww&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1716058845923-9212b7e0887b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwd2FybSUyMGludGVyaW9yJTIwZGluaW5nJTIwcm9tZXxlbnwwfHx8fDE3ODk5ODEzMzZ8MA&ixlib=rb-4.1.0&q=85",
  seafood:
    "https://images.unsplash.com/photo-1676471926534-d5c9771909fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxmaW5lJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMGZvb2QlMjBwbGF0aW5nfGVufDB8fHx8MTc4OTk4MTMzNnww&ixlib=rb-4.1.0&q=85",
  beef: "https://images.unsplash.com/photo-1694345598429-00511c301452?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxncmlsbGVkJTIwc3RlYWslMjBzZWFmb29kJTIwZ291cm1ldCUyMGRpc2h8ZW58MHx8fHwxNzg5OTgxMzM2fDA&ixlib=rb-4.1.0&q=85",
  grill:
    "https://images.pexels.com/photos/11374421/pexels-photo-11374421.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  salotto:
    "https://images.unsplash.com/photo-1617562593428-9dfd3376a14e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxyZXN0YXVyYW50JTIwd2FybSUyMGludGVyaW9yJTIwZGluaW5nJTIwcm9tZXxlbnwwfHx8fDE3ODk5ODEzMzZ8MA&ixlib=rb-4.1.0&q=85",
  plating:
    "https://images.unsplash.com/photo-1616671285410-2a676a9a433d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxmaW5lJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMGZvb2QlMjBwbGF0aW5nfGVufDB8fHx8MTc4OTk4MTMzNnww&ixlib=rb-4.1.0&q=85",
};

export const GALLERY = [
  { src: PHOTOS.plates, alt: "I piatti rigati nella luce di taglio", alt_en: "Striped plates in raking light", tall: true },
  { src: PHOTOS.dishPrawn, alt: "Pasta fresca e gambero rosso", alt_en: "Fresh pasta & red prawn", tall: true },
  { src: PHOTOS.sketches, alt: "Gli studi preliminari del ristorante", alt_en: "The restaurant's preliminary sketches", tall: false },
  { src: PHOTOS.sala, alt: "La sala e le sue lampade", alt_en: "The dining room and its lamps", tall: false },
  { src: PHOTOS.corridor, alt: "Il corridoio ambrato", alt_en: "The amber corridor", tall: false },
  { src: PHOTOS.lamp, alt: "La lampada della sala", alt_en: "The dining room lamp", tall: true },
  { src: PHOTOS.tableSetting, alt: "La mise en place", alt_en: "The table setting", tall: true },
  { src: PHOTOS.wineNiche, alt: "La nicchia dei vini", alt_en: "The wine niche", tall: false },
];

export const INSTAGRAM_GRID = [
  PHOTOS.plates,
  PHOTOS.dishPrawn,
  PHOTOS.sala,
  PHOTOS.tableSetting,
  PHOTOS.wineNiche,
  PHOTOS.lamp,
];
